import { Link } from "react-router-dom";
import type { EventData } from "@/mocks/events";
import { categoryNameMap } from "@/mocks/site";

function statusToneClass(tone: EventData["statusTone"]) {
  if (tone === "hot") return "bg-primary-500 text-background-50";
  if (tone === "cool") return "bg-secondary-200 text-foreground-700";
  return "bg-accent-100 text-accent-900";
}

export default function EventCard({
  event,
  hideMeta = false,
}: {
  event: EventData;
  hideMeta?: boolean;
}) {
  const catName = categoryNameMap[event.categorySlug] || event.category;
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200">
      <Link to={`/events/${event.slug}`} className="relative block overflow-hidden" aria-label={event.title}>
        <div className="aspect-[4/3] w-full overflow-hidden bg-background-200">
          <img
            src={event.cover}
            alt={event.coverAlt}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <span
          className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-xs font-medium ${statusToneClass(
            event.statusTone,
          )}`}
        >
          {event.status}
        </span>
        <span className="absolute bottom-3 left-3 rounded-full bg-background-50/85 px-2.5 py-1 text-xs text-foreground-700 backdrop-blur">
          {catName}
        </span>
      </Link>

      <div className="flex flex-1 flex-col p-4 md:p-5">
        <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
          <Link to={`/events/${event.slug}`} className="line-clamp-2">
            {event.title}
          </Link>
        </h3>
        {!hideMeta && (
          <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
            {event.summary}
          </p>
        )}

        <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1.5">
            <i className="ri-time-line text-sm" aria-hidden="true"></i>
            更新于 {event.updated}
          </span>
          <span className="flex items-center gap-3">
            <span className="flex items-center gap-1 text-accent-700">
              <i className="ri-fire-fill" aria-hidden="true"></i>
              {event.heat}
            </span>
            <span className="hidden items-center gap-1 sm:flex">
              <i className="ri-eye-line text-sm" aria-hidden="true"></i>
              {event.readingMinutes} 分钟
            </span>
          </span>
        </div>
      </div>
    </article>
  );
}